module.exports = __webpack_public_path__ + "img/server_web.dd83abb1.svg";